/** Paginación de mensajes al abrir chat Twilio (últimos N + scroll hacia arriba). */
export default {
  data: () => ({
    mensajesHasMore: false,
    mensajesCargandoMas: false,
    mensajesOldestCursor: null,
    mensajesChatActivo: null,
    MENSAJES_POR_PAGINA: 20,
  }),

  methods: {
    resetPaginacionMensajes () {
      this.mensajesHasMore = false
      this.mensajesCargandoMas = false
      this.mensajesOldestCursor = null
      this.mensajesChatActivo = null
    },

    aplicarRespuestaMensajesChat (response, { append = false } = {}) {
      const data = response.data || {}
      const nuevos = Array.isArray(data.conversacionCompleta) ? data.conversacionCompleta : []

      if (append) {
        const existentes = new Set(
          this.mensajes.map((m) => m.idmensajes || m.messageSid || `${m.fecha_creacion}-${m.mensaje}`)
        )
        const paraAgregar = nuevos.filter((m) => {
          const key = m.idmensajes || m.messageSid || `${m.fecha_creacion}-${m.mensaje}`
          return !existentes.has(key)
        })
        this.mensajes = paraAgregar.concat(this.mensajes)
      } else {
        this.mensajes = nuevos
      }

      this.mensajesHasMore = !!data.hasMore
      this.mensajesOldestCursor = data.oldestCursor || null
      return data
    },

    onScrollMensajesChat (e) {
      if (!e || !e.target) return
      if (e.target.scrollTop > 100) return
      if (!this.mensajesHasMore || this.mensajesCargandoMas || !this.mensajesChatActivo) return
      this.cargarMasMensajesChat(e.target)
    },

    async cargarMasMensajesChat (scrollEl) {
      if (!this.mensajesChatActivo || !this.mensajesOldestCursor) return

      const el = scrollEl || document.getElementById('scroll-target')
      const prevHeight = el ? el.scrollHeight : 0
      const prevTop = el ? el.scrollTop : 0

      this.mensajesCargandoMas = true

      try {
        const payload = {
          ...this.mensajesChatActivo,
          limit: this.MENSAJES_POR_PAGINA,
          before: this.mensajesOldestCursor,
        }
        const response = await this.$http.post('twilio.chats.unico', payload)
        this.aplicarRespuestaMensajesChat(response, { append: true })

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (!el) return
              el.scrollTop = el.scrollHeight - prevHeight + prevTop
            })
          })
        })
      } catch (error) {
        const msg = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error al cargar mensajes anteriores'
        if (typeof this.validarError === 'function') {
          this.validarError(msg)
        }
      } finally {
        this.mensajesCargandoMas = false
      }
    },
  },
}
